import { render, staticRenderFns } from "./TaskEdit.vue?vue&type=template&id=f83f8d92&scoped=true"
import script from "./TaskEdit.vue?vue&type=script&lang=js"
export * from "./TaskEdit.vue?vue&type=script&lang=js"
import style0 from "./TaskEdit.vue?vue&type=style&index=0&id=f83f8d92&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83f8d92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f83f8d92')) {
      api.createRecord('f83f8d92', component.options)
    } else {
      api.reload('f83f8d92', component.options)
    }
    module.hot.accept("./TaskEdit.vue?vue&type=template&id=f83f8d92&scoped=true", function () {
      api.rerender('f83f8d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/preScreening/task/TaskEdit.vue"
export default component.exports